import { getMarket } from '../i18n';

export const resolveArticlesRoute = () => {
  const { marketCode } = getMarket();
  switch (marketCode) {
    case 'NO':
      return 'artikler';
    default:
      return 'artiklar';
  }
};

export const resolveAuthorsRoute = () => {
  const { marketCode } = getMarket();
  switch (marketCode) {
    case 'NO':
      return 'forfattere';
    default:
      return 'skribenter';
  }
};

export const resolveCarValuationRoute = () => {
  const { marketCode } = getMarket();
  switch (marketCode) {
    case 'NO':
      return 'verdivurdere-bil';
    default:
      return 'vardera-bil';
  }
};

export const resolveAssignmentRoute = () => {
  const { marketCode } = getMarket();
  switch (marketCode) {
    case 'NO':
      return 'selg-til-forhandler';
    default:
      return 'salj-till-handlare';
  }
};

export const resolveAssignmentPublishedRoute = () => {
  const { marketCode } = getMarket();
  switch (marketCode) {
    case 'NO':
      return 'publisert';
    default:
      return 'publicerad';
  }
};

export const resolveAssignmentCreatePartialPath = () => {
  const { marketCode } = getMarket();
  switch (marketCode) {
    case 'NO':
      return 'opprett';
    default:
      return 'skapa';
  }
};
